import { render, staticRenderFns } from "./BlockType3.vue?vue&type=template&id=11a33f1e&"
import script from "./BlockType3.vue?vue&type=script&lang=ts&"
export * from "./BlockType3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports